__webpack_public_path__ = window.__webpack_public_path__;

import "default";

function forwardAttributionParamsToAppLinks() {
  const currentParams = new URLSearchParams(window.location.search);
  if (!currentParams.toString()) return;

  const allowlist = window.__pico_query_params_allowlist || [];
  const currentHost = location.hostname;

  document.querySelectorAll('a[href]').forEach(link => {
    try {
      const url = new URL(link.href, location.origin);
      const isLoomlyLink = url.hostname === 'loomly.com' || url.hostname.endsWith('.loomly.com');
      if (url.hostname !== currentHost && isLoomlyLink) {
        allowlist.forEach(key => {
          const value = currentParams.get(key);
          if (value != null && !url.searchParams.has(key)) {
            url.searchParams.set(key, value);
          }
        });
        link.href = url.toString();
      }
    } catch (e) {}
  });
}

document.addEventListener('turbo:load', forwardAttributionParamsToAppLinks);
